import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  style: {"background-color":"#ffffff"},
  class: "w-100 h-100"
}
const _hoisted_2 = { class: "w-100 h-100" }
const _hoisted_3 = { style: {"margin-left":"1%"} }
const _hoisted_4 = { class: "table-div" }
const _hoisted_5 = {
  key: 0,
  id: "tblUserInfo"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", { class: "first-td" }, "User ID", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", { class: "first-td" }, "Given Name", -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", { class: "first-td" }, "Family Name", -1 /* HOISTED */)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "first-td" }, "Email", -1 /* HOISTED */)
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { style: {"text-align":"left","color":"red"} }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { class: "first-td" }, "Email", -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "2" })
], -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { class: "first-td" }, "Status", -1 /* HOISTED */)
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", { class: "first-td" }, "Station Code", -1 /* HOISTED */)
const _hoisted_19 = ["value"]
const _hoisted_20 = { key: 3 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", { class: "first-td" }, "Station Code", -1 /* HOISTED */)
const _hoisted_22 = { key: 4 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", { class: "first-td" }, "Distributor", -1 /* HOISTED */)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "2" })
], -1 /* HOISTED */)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", { class: "first-td" }, "Country ID", -1 /* HOISTED */)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "first-td" }, "Country", -1 /* HOISTED */)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "2" })
], -1 /* HOISTED */)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", { class: "first-td" }, "Department", -1 /* HOISTED */)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "2" })
], -1 /* HOISTED */)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", { class: "first-td" }, "CREATED_DATE", -1 /* HOISTED */)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", { class: "first-td" }, "LAST_UPDATE", -1 /* HOISTED */)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", { class: "first-td" }, "LAST_ACCESS", -1 /* HOISTED */)
const _hoisted_33 = { style: {"margin-left":"30%","margin-right":"30%"} }
const _hoisted_34 = { class: "mb-3 mt-3" }
const _hoisted_35 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode($setup["Alert"], {
          alertMessage: $setup.alertMessage,
          alertState: $setup.alertState
        }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
      ]),
      _createVNode($setup["UserNavigation"], { menuTile: $setup.title }, null, 8 /* PROPS */, ["menuTile"]),
      _createElementVNode("div", _hoisted_4, [
        ($setup.userinfoList.length == 1)
          ? (_openBlock(), _createElementBlock("table", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userinfoList, (info, index) => {
                return (_openBlock(), _createElementBlock("tbody", { key: index }, [
                  _createElementVNode("tr", null, [
                    _hoisted_6,
                    _createElementVNode("td", null, _toDisplayString(info.userId), 1 /* TEXT */)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_7,
                    _createElementVNode("td", null, _toDisplayString(info.givenName), 1 /* TEXT */)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_8,
                    _createElementVNode("td", null, _toDisplayString(info.familyName), 1 /* TEXT */)
                  ]),
                  ($setup.store.getters.Flg == 'UserMaintenance')
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control",
                            disabled: info.userId.length == 6,
                            style: {"text-align":"center","width":"100% !important","margin":"0","border":"2px solid #ccc"},
                            id: "StationCode",
                            maxlength: "100",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.targetEmail) = $event))
                          }, null, 8 /* PROPS */, _hoisted_11), [
                            [_vModelText, $setup.targetEmail]
                          ]),
                          _createElementVNode("span", _hoisted_12, _toDisplayString($setup.emailError), 1 /* TEXT */)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("td", null, _toDisplayString(info.email), 1 /* TEXT */)
                      ])),
                  _hoisted_15,
                  _createElementVNode("tr", null, [
                    _hoisted_16,
                    _createElementVNode("td", null, _toDisplayString(info.status), 1 /* TEXT */)
                  ]),
                  ($setup.store.getters.Flg == 'UserMaintenance')
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("select", {
                            class: "adjusting-position form-select",
                            style: {"width":"100% !important","margin":"0"},
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.targetStationCode) = $event))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.destinationList, (destination, index) => {
                              return (_openBlock(), _createElementBlock("option", {
                                class: "adjusting-option",
                                key: index,
                                value: destination.stationCode
                              }, _toDisplayString(destination.stationCode) + " : " + _toDisplayString(destination.companyName), 9 /* TEXT, PROPS */, _hoisted_19))
                            }), 128 /* KEYED_FRAGMENT */))
                          ], 512 /* NEED_PATCH */), [
                            [_vModelSelect, $setup.targetStationCode]
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("td", null, _toDisplayString(info.stationcode), 1 /* TEXT */)
                      ])),
                  ($setup.store.getters.Flg != 'UserMaintenance')
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("td", null, _toDisplayString(info.companyName), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  _hoisted_24,
                  _createElementVNode("tr", null, [
                    _hoisted_25,
                    _createElementVNode("td", null, _toDisplayString(info.countryCode), 1 /* TEXT */)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_26,
                    _createElementVNode("td", null, _toDisplayString(info.country), 1 /* TEXT */)
                  ]),
                  _hoisted_27,
                  _createElementVNode("tr", null, [
                    _hoisted_28,
                    _createElementVNode("td", null, _toDisplayString(info.department), 1 /* TEXT */)
                  ]),
                  _hoisted_29,
                  _createElementVNode("tr", null, [
                    _hoisted_30,
                    _createElementVNode("td", null, _toDisplayString(info.createdDate), 1 /* TEXT */)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_31,
                    _createElementVNode("td", null, _toDisplayString(info.updatedDate), 1 /* TEXT */)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_32,
                    _createElementVNode("td", null, _toDisplayString(info.lastAccessDate), 1 /* TEXT */)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("button", {
            class: "btn btn-secondary btnUserBack",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.goBack()))
          }, "Back"),
          ($setup.store.getters.Flg == 'UserMaintenance')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-primary btnUserEdit",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.updateUserInfo()))
              }, "Update"))
            : _createCommentVNode("v-if", true),
          ($setup.isAuthForLogin == true && $setup.userId != $setup.store.getters.cognitoUserName)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                disabled: $setup.store.state.isAltLogin == true,
                class: "btn btn-primary btnUserEdit",
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.goAltLogin()))
              }, "Login", 8 /* PROPS */, _hoisted_35))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ])
  ]))
}